<template>
  <div class="card rounded-5 p-0 col-12 col-md-12 col-lg-5 col-xl-4">
    <div
      :class="[
        useAffiliateHeaderBg ? 'has-affiliate-header' : null
      ]"
      class="header">
      <NuxtImg width="132" v-if="!!affiliateCustomizations && !!appNavLogo" :src="formatImagePath(appNavLogo)" />
      <NuxtImg v-else src="/images/logo-default-dark.svg" width="132" alt="Lendio" />
    </div>
    <div class="card-body">
      <h1 class="title mb-4">
        <slot name="title" />
      </h1>
      <Alert ref="warningBanner" class="mb-5" />
      <Alert ref="alert" class="mb-5" />
      <main class="main mb-5">
        <slot name="main" />
      </main>
      <div class="actions">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useAffiliateCustomizationStore } from '~/store/affiliate-customization'
import Alert from '../Alert.vue'
import formatImagePath from '~/libs/image-format'

export default {
  name: 'IdentityCard',
  components: [
    Alert,
  ],
  async setup() {
    const affiliateStore = useAffiliateCustomizationStore()

    const useAffiliateHeaderBg = ref(false)

    if (affiliateStore?.affiliateCustomizations?.app_styles?.appAsideBackgroundColor) {
        // If the background exists then we will do all the special style formatting
        useAffiliateHeaderBg.value = true
    }


    return {
      formatImagePath,
      useAffiliateHeaderBg,
    }
  },
  computed: {
    ...mapState(useAffiliateCustomizationStore, [
      'affiliateCustomizations',
      'appNavLogo',
    ]),

  }
}
</script>

<style lang="scss" scoped>
@import "lendio-card";
.card {
  max-width: 428px;
}
@media (max-width: 768px) {
  .card {
    height: 100vh;
    border-radius: 0px !important;
    max-width: 100vh;
    @include media-breakpoint-down(md) {
      border: none;
    }
  }
}
.header {
  padding: 24px;
  border-bottom: 1px solid #E5E0DD;
}
.header.has-affiliate-header {
  background: $app-aside-background-color;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  margin-left: calc(var(--bs-border-width) * -1);
  margin-top: calc(var(--bs-border-width) * -1);
  margin-right: calc(var(--bs-border-width) * -1);
  border-top: 1px solid $app-card-border-color;
  border-left: 1px solid $app-card-border-color;
  border-right: 1px solid $app-card-border-color;
  @include media-breakpoint-down(md) {
    margin-left: 0;
    margin-top: 0;
    margin-right: 0;
    border-top: none;
    border-left: none;
    border-right: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
}
.title {
  font-size: 32px;
  font-weight: 400;
  line-height: 40px;
  text-align: left;
}
.card-body {
  padding: 24px;
}
</style>
